<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Puzzle-Number-Square-Generator-Root',
};
</script>
